var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverlaySwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.147437 3.14645C-0.167546 3.46143 0.0555387 4 0.500991 4H2.29388V7V11.8V12.5C2.29388 12.7761 2.51774 13 2.79388 13H3.79388C4.07003 13 4.29388 12.7761 4.29388 12.5V11.8V10.6V7V4H6.08678C6.53223 4 6.75531 3.46143 6.44033 3.14645L3.64744 0.353553C3.45218 0.158291 3.13559 0.158291 2.94033 0.353553L0.147437 3.14645Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.147437 3.14645C-0.167546 3.46143 0.0555387 4 0.500991 4H2.29388V7V11.8V12.5C2.29388 12.7761 2.51774 13 2.79388 13H3.79388C4.07003 13 4.29388 12.7761 4.29388 12.5V11.8V10.6V7V4H6.08678C6.53223 4 6.75531 3.46143 6.44033 3.14645L3.64744 0.353553C3.45218 0.158291 3.13559 0.158291 2.94033 0.353553L0.147437 3.14645Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14744 9.85355C7.83245 9.53857 8.05554 9 8.50099 9H10.2939L10.3393 6V1.2V0.5C10.3393 0.223858 10.5632 0 10.8393 0H11.8393C12.1155 0 12.3393 0.223858 12.3393 0.5V1.2V2.4V6L12.2939 9L14.0868 9C14.5322 9 14.7553 9.53857 14.4403 9.85355L11.6474 12.6464C11.4522 12.8417 11.1356 12.8417 10.9403 12.6464L8.14744 9.85355Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14744 9.85355C7.83245 9.53857 8.05554 9 8.50099 9H10.2939L10.3393 6V1.2V0.5C10.3393 0.223858 10.5632 0 10.8393 0H11.8393C12.1155 0 12.3393 0.223858 12.3393 0.5V1.2V2.4V6L12.2939 9L14.0868 9C14.5322 9 14.7553 9.53857 14.4403 9.85355L11.6474 12.6464C11.4522 12.8417 11.1356 12.8417 10.9403 12.6464L8.14744 9.85355Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlaySwitch);
export default __webpack_public_path__ + "static/media/OverlaySwitch.a7d20567af63f6ef9cf2a4968cdbea6f.svg";
export { ForwardRef as ReactComponent };